export const getTermsAndConditions = (banner) => {
    const { termsAndConditions } = banner;
    if (!termsAndConditions || !termsAndConditions.label || !termsAndConditions.url)
        return null;
    return termsAndConditions;
};
